import { toRawDoc } from 'tio-employee/demo/identity-fixtures';
import type { FetchMatcher, JsonApiResource } from 'tio-data/demo/types';

/** Each name must match a `SERVICERS` key in `services/observability.ts`, or the drawer goes generic. */
const DEMO_SERVICERS = [
  { id: 'demo-fi-mohela', name: 'MOHELA' },
  { id: 'demo-fi-nelnet', name: 'Nelnet' },
  { id: 'demo-fi-aidvantage', name: 'Aidvantage' },
  { id: 'demo-fi-edfinancial', name: 'Edfinancial Services' },
  { id: 'demo-fi-aes', name: 'American Education Services' },
];

const servicerResource = ({ id, name }: { id: string; name: string }): JsonApiResource => ({
  type: 'financial-institution',
  id,
  attributes: { name, isActive: true, hasObservabilityInstructions: true },
});

/** Anchored on the query: `validateAccountNumberRequest` falls through to this seam too. */
const isObservabilityCatalogRead = (url: string) =>
  /\/financial-institutions\?/.test(url) && /hasObservabilityInstructions/i.test(url);

/** Fetch-seam matcher for the upload form's servicer catalog. */
export function buildFinancialInstitutionFetchMatchers(): FetchMatcher[] {
  const data = DEMO_SERVICERS.map(servicerResource);

  return [
    {
      urlMatches: isObservabilityCatalogRead,
      method: 'GET',
      json: toRawDoc({ data, meta: { page: { total: data.length } } }),
    },
  ];
}
